const en = {
  select_from_gallary: 'select from gallary',
  upload_picture_error: 'Upload picture in jpg format and maximum 10Gb is only allowed.',
  confirmation_modal_alert: 'You can only send one voice message, are you sure to send it?',
  send: 'send',
  cancel: 'cancel',
  ticket_status: 'Ticket Status',
  category: 'Category',
  voice_hint_1: 'Send your request in ',
  voice_hint_2: 'a voice message',
  voice_hint_3: 'with maximum',
  voice_hint_4: '3 minutes',
  voice_hint_5: 'limitation.',
  record_your_voice: 'Record your voice',
  write_your_message: 'Write your message...',
  change_status_alert: 'Change ticket status before exit.',
  message_limit_alert: 'You can only send a voice message',
  category_limit_alert: 'در این دسته‌بندی نمی‌توانید پیام صوتی ارسال کنید و فقط می‌توانید پیام متنی ارسال کنید.',
  estekhare_header_1: 'لطفا با توجه به موارد زیر تعداد نیات خود را درج نمایید:',
  estekhare_header_2: 'برای انجام هر فعل یک نیت لازم است و نیت نباید بین این دو فعل انجام شود، مثلا اگر صلاح است فلان وسیله را بخرم استخاره خوب بیاید و اگر صلاح نیست بد بیاید نه به این صورت نیت کنید که این وسیله را بخرم یا نخرم.',
  estekhare_header_3: 'اگر برای یک موضوع چند مطلب هست، مثلا سه مدرسه برای ثبت نام مدنظر دارم، برای هر کدام یک نیت به صورت مجزا انجام شود و حتما قید گردد که این استخاره مقایسه‌ای است، یعنی از بین این سه مورد کدام بهتر است.',
  estekhare_header_4: 'استخاره‌های ترک صرفا برای استخاره‌های خوب می‌باشد و استخاره بد نیاز به ترک ندارد، چنانچه نیاز به ترک استخاره داشتید حتما در پیام قید بفرمایید.',
  estekhare_header_5: 'لطفا قبل از ارسال، صوت زیر را با دقت گوش نموده و بر اساس آن عمل نمایید.'
}

export  default en
